import { useLocation } from 'react-router-dom';
import { ConfirmationTemplate } from '@templates';
import {
  resetIssueDetails,
  usePlanningBreachStore,
} from '@planning-breach/hooks/usePlanningBreachStore';
import { REPORT_IT_WEBSITE_LINK, RETURN_TO_HOME_PAGE_TEXT } from '@constants';
import { usePreventConfirmationReturn } from '@hooks';
import { RoutesList } from '../../../../routes/Routes';
import { basename } from '../../../../routes/basename';

export const Confirmation = () => {
  const {
    data: {
      receiveConfirmationEmail,
      caseReferenceId,
      contactUserOption,
      email,
      issueLocationData,
    },
  } = usePlanningBreachStore();

  const contentTitle = `What happens next?`;
  const location = useLocation();

  usePreventConfirmationReturn({
    confirmationUrl: basename + RoutesList.CONFIRMATION,
    redirectUrl: REPORT_IT_WEBSITE_LINK,
    onReset: resetIssueDetails,
    dependencies: [location.pathname],
  });

  let sla = '6 working days';
  // If asset exists, its a listed building and SLA is 1 working day
  if (issueLocationData?.asset) {
    sla = '1 working day';
  }

  let subText1;
  let subText2;

  if (receiveConfirmationEmail === 'Yes') {
    subText1 = <p>We have sent a confirmation email to {email}</p>;
    if (contactUserOption === 'Yes') {
      subText2 = (
        <p>We may contact you by phone or email if we need more information.</p>
      );
    } else {
      subText2 = <p>You won’t be contacted further about the issue.</p>;
    }
  } else {
    if (contactUserOption === 'Yes') {
      subText2 = (
        <p>We may contact you by phone or email if we need more information.</p>
      );
    } else {
      subText1 = (
        <p>Your report has been received and will be reviewed by our team.</p>
      );
      subText2 = (
        <p>
          As you did not leave your contact details you will not receive a
          confirmation email.
        </p>
      );
    }
  }

  const contentSubtext = (
    <div className="text-bodyLg text-text-body flex flex-col gap-6">
      {subText1}
      {subText2}
      <p className="mb-4">
        We aim to visit the property reported in your complaint within {sla}.
      </p>
    </div>
  );

  const navigationButton = {
    label: RETURN_TO_HOME_PAGE_TEXT,
    isExternalLink: true,
    href: REPORT_IT_WEBSITE_LINK,
  };

  return (
    <ConfirmationTemplate
      reference={caseReferenceId}
      contentTitle={contentTitle}
      contentSubtext={contentSubtext}
      feedbackLink={true}
      button={navigationButton}
    />
  );
};
